import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Container } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router-dom"; // ⬅️ Required
import { isTokenExpired } from "../utils/isTokenExpired";
import Footer from "./Footer";

function Layout() {
  const [showSidebar, setShowSidebar] = useState(true);
  const [isMobile, setIsMobile] = useState(false);


  const mainContainerStyles = showSidebar
    ? {
        position: "relative",
        left: "18%",
        width: "81%",
      }
    : {
        width: "100%",
      };

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || isTokenExpired(token)) {
      localStorage.removeItem("token");
      navigate("/");
    }
  }, [navigate]);

  function mobileView(params) {
    const mediaQueryList = window.matchMedia(`(max-width: 767px)`);
    if (mediaQueryList.matches) {
      setShowSidebar(false);
      setIsMobile(true)
    } else{
      setIsMobile(false)
      setShowSidebar(true);
    }
  }

  useEffect(() => {
    mobileView();
    window.addEventListener("resize", mobileView)
  },[]);

  return (
    <>
      <Header toggleSidebar={() => setShowSidebar(!showSidebar)} />
      <div style={{ display: "flex" }}>
        <Sidebar setShowSidebar={setShowSidebar} show={showSidebar} isMobile={isMobile}/>
        <div style={mainContainerStyles}>
          <Container fluid className="main-panel">
            <Outlet />
          </Container>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Layout;
